import { render, staticRenderFns } from "./withdrawalRecord.vue?vue&type=template&id=ac397ce8&scoped=true&"
import script from "./withdrawalRecord.vue?vue&type=script&lang=js&"
export * from "./withdrawalRecord.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalRecord.vue?vue&type=style&index=0&id=ac397ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac397ce8",
  null
  
)

export default component.exports